import React, { useState } from "react";
import CompanyAPIs from "../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import { useNavigate } from "react-router-dom";
import ApiResponseHandler from "../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { Collapse, Form } from "react-bootstrap";
import { MdAddCircle } from "react-icons/md";
import { useToast } from "../../../../../Contexts/ToastContext";

function CreateEmployee({companyID, handleAddNew}){
    
    const {addToast} = useToast();
    const navigate = useNavigate();
    const [addNew, setAddNew] = useState(false);
    const [sending, setSending] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setSending(true);
        const postJSON = {
            first_name: firstName,
            last_name: lastName,
            phone: phone,
            email: email,
            employee_type_id: 1
        }

        if(
            firstName !== '' &&
            lastName !== ''
        ){
            CompanyAPIs.PostCompanyEmployee(companyID, postJSON)
            .then((response) => {
                if(response.status === 200){
                    handleAddNew();
                    setSending(false);
                    handleCancel();
                    addToast({ message: "Employee added successfully!", variant: "success", autoHide: true });

                }
            })
            .catch((err) => {
                setSending(false);
                ApiResponseHandler(err.response, navigate)
            })     
        }
        else{
            setSending(false);
        }
    }
    

    const handleCancel = () => {
        if(addNew){
            setFirstName('');
            setLastName('');
            setEmail('');
            setPhone('');
        }

        setAddNew(!addNew);
    }

    return(

        <div className="project-section">
            <Form onSubmit={handleSubmit}>
                <div className="project-header-actions">
                    <button
                        disabled={sending || !addNew}
                        type="submit"
                        className="save-btn"
                        style={addNew ? {display: 'block'} : {display: 'none'}}
                    >
                        {sending ? 'Saving...' : 'Save'}
                    </button>
    
                        <button
                            disabled={sending}
                            type="button"
                            className="cancel-btn"
                            onClick={() => handleCancel()}
                        >
                            {addNew ? 'Cancel' : <><MdAddCircle /> Add New</>}
                        </button>
                    
                </div>
                <Collapse in={addNew}>
                    <div className="project-section-body">

                        <div className="project-section-body-item m-1">
                            <span className="label">First Name:</span>
                            <Form.Control className='editable-field' required value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                        </div>
                        <div className="project-section-body-item m-1">
                            <span className="label">Last Name:</span>
                            <Form.Control className='editable-field' required value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        </div>

                        <div className="project-section-body-item m-1">
                            <span className="label">Email:</span>
                            <Form.Control type='email' className='editable-field' value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>

                        <div className="project-section-body-item m-1">
                            <span className="label">Phone:</span>
                            <Form.Control className='editable-field' value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>
                        
                    </div>
                </Collapse>
            </Form>
        </div>
        // <tr>
        //     <td><input disabled={sending} onChange={(e) => setFirstName(e.target.value)} required value={firstName} /></td>
        //     <td><input disabled={sending} onChange={(e) => setLastName(e.target.value)} required value={lastName} /></td>
        //     <td><input disabled={sending} onChange={(e) => setPhone(e.target.value)} required value={phone} /></td>
        //     <td><input disabled={sending} onChange={(e) => setEmail(e.target.value)} value={email} /></td>
        //     <td><button disabled={sending} onClick={() => addNewEmployee()}>{sending ? 'Creating...' : 'Create'}</button></td>
        // </tr>
    )
}
export default CreateEmployee;